import { h } from "preact";
import { useState } from "preact/hooks";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import Localisation3 from "./Localisation3";


export default function UserDetails2v2({ state, handleChange, noUpdate }) {
	const [localState, setLocalState] = useState({ new_loc: false });
	return (
		<div style="padding: 10px">
			<Grid container spacing={2}>
				{!noUpdate && <Grid item xs={(!state.addr_line1 || localState.new_loc) ? 12 : 6}>
					{/* <Box display="flex" justifyContent={"space-between"} alignItems="center" >
						<Box> */}

					<Stack spacing={1} justifyContent="flex-start">
						{(!state.addr_line1 || localState.new_loc) && <Localisation3 upperState={state} mode="USR" upperSendLoc={handleChange} />}
						{!localState.new_loc && state.addr_line1 && <div>
							<Button variant="contained" onClick={() => { setLocalState({ ...localState, new_loc: true }) }}>Modifier</Button>
						</div>}
						{localState.new_loc && <div>

							<Button variant="contained" onClick={() => { setLocalState({ ...localState, new_loc: false }) }}>Annuler</Button>
						</div>}
					</Stack>

				</Grid>}
				{(!localState.new_loc && state.addr_line1) && <Grid item xs={6}>
					{state.addr_line1 !== "" && <Stack spacing={1} style="margin-top: 10px;">

						<Typography variant="h5">Adresse actuelle</Typography>


						{state.addr_line1 !== "" &&

							<Typography variant="body1">{state.addr_line1}</Typography>

						}
						{state.addr_line2 && <Typography variant="body1">{state.addr_line2}</Typography>}

						<Box display={"flex"} justifyContent="flex-start" alignItems={"center"} >
							<Box>
								<Typography variant="body1">{state.addr_zip_code}</Typography>
							</Box>
							<Box p={1}>
								<Typography variant="body1">{state.addr_city}</Typography>
							</Box>
						</Box>

					</Stack>}
					{state.addr_line1 === "" && <Typography variant="body1" style="margin-top: 10px;">Adresse incomplète</Typography>}

				</Grid>
				}
			</Grid>



		</div>
	);
}
